module.exports = __webpack_public_path__ + "img/introductionBgImg5.9dcee406.png";